<div class="card custom-card">
  <div class="d-flex justify-content-between align-items-center p-3 p-md-4 pb-3">
    <span class="text-header">Closing balance by branch</span>
    <!-- View Toggle -->
    <div class="d-flex gap-2 view-toggle">
      <button class="btn btn-sm rounded-2" [class.active]="viewMode === 'table'" (click)="setViewMode('table')">
        <img src="assets/table.svg" alt="Table View" width="18">
      </button>
      <button class="btn btn-sm rounded-2" [class.active]="viewMode === 'chart'" (click)="setViewMode('chart')">
        <img src="assets/graph.svg" alt="Chart View" width="18">
      </button>
    </div>
  </div>

  <div class="px-md-4 px-2 pb-md-4 pb-2 position-relative">
    <!-- Loading -->
    @if (loading) {
      <div class="d-flex justify-content-center align-items-center graph-state-container">
        <output class="spinner-border text-secondary" aria-hidden="true"></output>
      </div>
    }

    <!-- Error -->
    @if (!loading && errorMessage) {
      <div
        class="d-flex justify-content-center align-items-center text-danger graph-state-container text-center px-3">
        {{ errorMessage }}
      </div>
    }

    <!-- Content Area -->
    @if (!loading && !errorMessage && (graph.data.length > 0 || tabledata.length > 0)) {
      <div>
        <!-- Chart View -->
        @if (viewMode === 'chart') {
          <div class="inner-graph-container">
            <plotly-plot class="plotly-graph-dimensions" [data]="graph.data" [layout]="graph.layout"
              [config]="graph.config" [useResizeHandler]="true">
            </plotly-plot>
          </div>
        }
        <!-- Table View -->
        @if (viewMode === 'table') {
          <div class="inner-table-container">
            <table class="table custom-table align-middle m-0">
              <thead>
                <tr>
                  <th>Branch name</th>
                  <th>Closing Qty</th>
                  <th>Average Price</th>
                  <th>Closing Value</th>
                  <th>Last Movement on</th>
                </tr>
              </thead>
              <tbody>
                @for (row of tabledata; track row) {
                  <tr>
                    <td>{{ row.company }}</td>
                    <td>{{ row.closingBalance }}</td>
                    <td>₹{{ row.avgPrice | number }}</td>
                    <td>₹{{ row.closingValue | number }}</td>
                    <td>{{ row.lastMoment }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    }

    <!-- Empty State -->
    @if (!loading && !errorMessage && graph.data.length === 0 && tabledata.length === 0) {
      <div
        class="d-flex justify-content-center align-items-center text-muted graph-state-container">
        No data available for the selected tyre.
      </div>
    }
  </div>
</div>
